import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["benefitMaxCount", "prefix"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-13 15:32:55
 * @LastEditTime: 2021-11-17 17:50:59
 * @LastEditors: wangshengqiang
 * @Description: 受益人组件
 */
import React, { useEffect } from 'react';
import { getState, useStore } from '@/store';
import { isPreviewMode } from '@/utils/tool';
import { Detail } from '../common';
import BeneficiaryItem from './Item';
import './index.less';

function updateFormKey2(configs, index) {
  const _formValueKey = `beneficiary[${index}]` || '';

  return configs.map(item => {
    return _objectSpread(_objectSpread({}, item), {}, {
      _formValueKey,
      formKey: item.formKey && item.formKey.replace('beneficiary', _formValueKey)
    });
  });
}

const Beneficiary = props => {
  const {
    attrs,
    children,
    Render
  } = props;

  const {
    benefitMaxCount,
    prefix = '受益人'
  } = attrs,
        rest = _objectWithoutProperties(attrs, _excluded);

  const isMutipleInsurant = getState('maxInsurant') > 1;
  const typeConfig = [];
  const restConfig = [];
  children.forEach(item => {
    // benefitSpecialType  beneficiaryType 旧
    if (item.component === 'beneficiaryType') {
      typeConfig.push(item);
    } else {
      restConfig.push(item);
    }
  });
  const holderName = useStore('formValues.policyHolder.name') || useStore('formValues.holder.name');

  const _insurants = useStore('formValues.insured');

  let insurants = Array.isArray(_insurants) ? _insurants : [_insurants];

  if (insurants.length === 0) {
    insurants = [{}];
  }

  useEffect(() => {}, []); // 根据投保人人数选择受益人

  return insurants.map((item, index) => {
    const config1 = updateFormKey2(typeConfig, index);
    const config2 = updateFormKey2(restConfig, index);
    item = item || {};
    const isSelf = item.holderRelation === 'self';
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "c-beneficiary__ins"
    }, isMutipleInsurant && /*#__PURE__*/React.createElement(Detail, {
      label: `被保人${index + 1}`,
      value: isSelf ? holderName : item.name
    }), isPreviewMode() ? /*#__PURE__*/React.createElement(Render, _extends({}, props, {
      components: children
    })) : /*#__PURE__*/React.createElement(BeneficiaryItem, _extends({
      groupIndex: index,
      typeConfig: config1,
      restConfig: config2,
      prefix: prefix,
      Render: Render
    }, rest)));
  });
};

export default Beneficiary;